// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/student_stats.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/schools/v1/resources/student_stats.proto.
 */
export const file_studyo_today_schools_v1_resources_student_stats = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc3R1ZGVudF9zdGF0cy5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIuUBCgxTdHVkZW50U3RhdHMSMgoObGFzdF9zZWVuX3RpbWUYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhcKD2xhdGVfd29ya19jb3VudBgCIAEoBRIYChBpbmJveF93b3JrX2NvdW50GAMgASgFEhgKEHRvZGF5X3dvcmtfY291bnQYBCABKAUSGwoTdXBjb21pbmdfd29ya19jb3VudBgFIAEoBRIXCg9kb25lX3dvcmtfY291bnQYBiABKAUSHgoWZW1vdGlvbmFsX3N0YXRlX3JhdGluZxgHIAEoBUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.schools.v1.resources.StudentStats.
 * Use `create(StudentStatsSchema)` to create a new message.
 */
export const StudentStatsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_student_stats, 0);

